import Connect from './__INNER/Connect'
import reduxLogger from './__INNER/reduxLogger'
import Provider from './__INNER/Provider'

import configureStore from './__INNER/configureStore'
import { buildActions } from './__INNER/actions'

import states from './state'

export { states }

export { Connect, reduxLogger, Provider, configureStore }

const actions = buildActions(states)

export type EasyActions = typeof actions

export type { EasyKeys, EasySetKeys, EasyStates, EasyUpperKeys } from './__INNER/States'
